import React, { useState } from "react";
// import styled from "styled-components/macro";
import Link from "gatsby-plugin-transition-link";

import PortableText from "../../components/Blog/portableText";
import tw from "twin.macro";
import styled1 from "@emotion/styled";

export const StyledContent = styled1.div`
  ul {
    ${tw`list-disc pl-7 mb-6 flex flex-col space-y-0.5`}
  }
  ol {
    ${tw`list-decimal pl-7 mb-6 flex flex-col space-y-0.5`}
  }  
  li > a{
    ${tw`relative w-full text-sm font-normal transition-[color] duration-300 ease-linear hover:font-semibold text-primary-400 hover:text-primary-500 no-underline  after:absolute after:left-auto after:right-0 after:-bottom-1 after:h-[.050rem] after:w-0 after:bg-tertiary-400 after:transition-all after:duration-300 after:ease-linear hover:after:left-0 hover:after:right-auto hover:after:w-full`}  
  div > button {
    ${tw` hover:text-primary-400`}
  }
`;
const QuestionContext = React.createContext();
export default function Banner({ children, ...restProps }) {
  return <div {...restProps}>{children}</div>;
}

Banner.Entity = function BannerEntity({ children, ...restProps }) {
  const [open, setOpen] = useState(false);
  return (
    <QuestionContext.Provider value={{ open, setOpen }}>
      <div {...restProps}> {children}</div>
    </QuestionContext.Provider>
  );
};

Banner.EntityNav = function BannerEntityNav({ children, ...restProps }) {
  const [open, setOpen] = useState(false);
  return (
    <QuestionContext.Provider value={{ open, setOpen }}>
      <div {...restProps}> {children}</div>
    </QuestionContext.Provider>
  );
};

Banner.Question = function BannerHeader({ children, ...restProps }) {
  const { open, setOpen } = React.useContext(QuestionContext);

  return (
    <button
      className="flex w-full items-center justify-between space-x-6 text-left no-underline"
      onClick={() => setOpen((open) => !open)}
    >
      <div className="font-body font-normal text-[20px] leading-[30px]">{children}</div>
      {open ? (
        <i className="fa-light fa-angle-up text-2xl text-primary-500 md:text-3xl"></i>
      ) : (
        <i className="fa-light fa-plus-large text-2xl text-primary-500 md:text-3xl"></i>
      )}
    </button>
  );
};
Banner.StyledContent = function BannerStyledContent({
  children,
  ...restProps
}) {
  const { open } = React.useContext(QuestionContext);

  return open
    ? children && (
        <div className="pt-6">
          <PortableText blocks={children} className="pt-6" />
        </div>
      )
    : null;
};

Banner.NavMenu = function BannerHeader({ children, ...restProps }) {
  const { open, setOpen } = React.useContext(QuestionContext);

  return (

      <button
        className="font-heading text-[34px] font-bold leading-[36px] hover:text-primary-500  text-primary-400 no-underline"
        onClick={() => setOpen((open) => !open)}
        {...restProps}
      >
        {children}
      </button>

  );
};

Banner.NavItem = function BannerText({ children, name, href, ...restProps }) {
  const { open } = React.useContext(QuestionContext);
  return open ? (
    <StyledContent>
      <li>
        <Link
          to={href}
          className="font-body text-[16px] font-normal text-primary-400/80 no-underline hover:text-primary-500"
        >
          {name}
        </Link>
      </li>
    </StyledContent>
  ) : null;
};
